module.exports = __webpack_public_path__ + "static/media/betting_games.48241e10.svg";